export default "import.meta.ROLLUP_FILE_URL_63925a98"